import JSZip from 'jszip';
import { base64ToUint8Array } from './officePreview';

// Tarefa 8.4 (FR-061): um .pptx e' um .zip de XML (OOXML) - sem biblioteca
// nova, reaproveita `jszip` (ja dependencia do frontend, usado por
// skillUpload.js/extractSkillFileName) e `DOMParser` (API nativa do
// navegador) para extrair o texto de cada slide. Decisao tomada com o
// usuario em 2026-08-14: sem fidelidade visual ao layout/posicionamento/
// imagens do slide original - so' o texto, exibido em cards limpos
// (SkillDetailView.js).

const SLIDE_PATH_RE = /^ppt\/slides\/slide(\d+)\.xml$/;

function slideNumber(path) {
    const match = SLIDE_PATH_RE.exec(path);
    return match ? parseInt(match[1], 10) : null;
}

// Texto de um paragrafo (<a:p>), juntando os runs (<a:t>) - preserva a
// separacao entre paragrafos (cada um vira uma linha), mas nao a formatacao
// (negrito/italico/etc.) nem quebras de linha manuais dentro do proprio run.
function paragraphText(paragraphEl) {
    return Array.from(paragraphEl.getElementsByTagName('a:t'))
        .map((run) => run.textContent)
        .join('');
}

function shapeText(shapeEl) {
    return Array.from(shapeEl.getElementsByTagName('a:p'))
        .map(paragraphText)
        .filter((line) => line.length > 0)
        .join('\n');
}

// Um shape e' o titulo do slide quando tem um placeholder <p:ph type="title">
// ou "ctrTitle" (titulo central, layout de slide de abertura) em
// <p:nvSpPr>/<p:nvPr> - mesma convencao usada pelo proprio PowerPoint.
function isTitleShape(shapeEl) {
    return Array.from(shapeEl.getElementsByTagName('p:ph'))
        .some((ph) => ['title', 'ctrTitle'].includes(ph.getAttribute('type')));
}

// Extrai {title, body} de um slide (DOM ja parseado) - o primeiro shape com
// texto que for um placeholder de titulo vira `title`; o texto de todos os
// demais shapes com texto (paragrafos separados por linha em branco) vira
// `body`. Slide sem nenhum texto (ex.: so' uma imagem) devolve os dois
// campos vazios - SkillDetailView.js decide como exibir esse caso.
function extractSlide(slideDoc) {
    let title = '';
    const bodyParts = [];

    Array.from(slideDoc.getElementsByTagName('p:sp')).forEach((shape) => {
        const text = shapeText(shape);
        if (!text) return;
        if (!title && isTitleShape(shape)) {
            title = text;
        } else {
            bodyParts.push(text);
        }
    });

    return { title, body: bodyParts.join('\n\n') };
}

function parseSlideXml(xmlText) {
    const doc = new DOMParser().parseFromString(xmlText, 'application/xml');
    if (doc.getElementsByTagName('parsererror').length > 0) return { title: '', body: '' };
    return extractSlide(doc);
}

// Devolve [{title, body}, ...] na ordem real dos slides (numerica, nao
// alfabetica - "slide10.xml" viria antes de "slide2.xml" numa ordenacao de
// string comum).
export async function parsePptxSlides(base64) {
    const bytes = base64ToUint8Array(base64);
    const zip = await JSZip.loadAsync(bytes);

    const slideEntries = Object.keys(zip.files)
        .map((path) => ({ path, number: slideNumber(path) }))
        .filter((entry) => entry.number !== null)
        .sort((a, b) => a.number - b.number);

    const slides = [];
    for (const entry of slideEntries) {
        const xmlText = await zip.files[entry.path].async('string');
        slides.push(parseSlideXml(xmlText));
    }
    return slides;
}
